import {
  brandEntityId,
  BrandEntityId,
  brandTitle,
  BrandTitle,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandUpdateRequest) {
    JsonSchemaValidator.assert(RoomBrandUpdateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "brandTitle"],
      properties: {
        roomId,
        brandId: brandEntityId,
        brandTitle
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandUpdateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  brandTitle: BrandTitle;
}
